const translations = {
  "en": {
    "Complete": "Complete",
    "Free": "Free",
    "Lifetime exclusives": "Lifetime exclusives",
    "What you get": "What you get"
  },
  "zh-tw": {
    "Complete": "Complete",
    "Free": "免費",
    "Lifetime exclusives": "終身專屬優惠",
    "What you get": "你將獲得"
  }
};

export default translations;
